// @ts-nocheck
import apiClient from "../utils/apiClient";

const orderApi = {
  createOrder: async (data) => {
    const response = await apiClient.post("/api/orders", data);
    return response.data;
  },

  getAllOrders: async () => {
    const response = await apiClient.get("/api/orders");
    return response.data;
  },

  getOrdersByUser: async (userId) => {
    if (!userId) {
      throw new Error("User ID is missing");
    }

    const response = await apiClient.get(`/api/orders/orderByUser/${userId}`);
    return response.data;
  },

  getMyOrders: async (userId) => {
    if (!userId) {
      throw new Error("User ID is missing");
    }

    const response = await apiClient.get(`/api/orders/my/${userId}`);
    return response.data;
  },

  getOrderById: async (id) => {
    const response = await apiClient.get(`/api/orders/${id}`);
    return response.data;
  },

  trackOrder: async (id) => {
    const response = await apiClient.get(`/api/orders/track/${id}`);
    return response.data;
  },

  deleteOrder: async (id, data) => {
    const response = await apiClient.delete(`/api/orders/${id}`, {
      data,
    });
    return response.data;
  },

  cancelOrder: async (id, data) => {
    const response = await apiClient.patch(`/api/orders/${id}/cancel`, data);
    return response.data;
  },

  updateOrder: async (id, data) => {
    const response = await apiClient.put(`/api/orders/${id}`, data);
    return response.data;
  },

  acceptOrder: async (id, userId) => {
    if (!userId) {
      throw new Error("User ID is missing");
    }

    const response = await apiClient.patch(`/api/orders/${id}/accept/${userId}`);
    return response.data;
  },

  assignOrder: async (id, adminId) => {
    const response = await apiClient.patch(`/api/orders/${id}/assign`, {
      adminId,
    });
    return response.data;
  },

  unassignOrder: async (id, data) => {
    const response = await apiClient.patch(`/api/orders/${id}/unassign`, data);
    return response.data;
  },

  rescheduleOrder: async (id, data) => {
    const response = await apiClient.patch(`/api/orders/${id}/reschedule`, data);
    return response.data;
  },

  sendDeliveryOtp: async (id, userId) => {
    if (!userId) {
      throw new Error("User ID is missing");
    }

    const response = await apiClient.post(`/api/orders/${id}/delivery-otp/${userId}`);
    return response.data;
  },

  deliverOrder: async (id, data) => {
    const response = await apiClient.patch(`/api/orders/${id}/deliver`, data);
    return response.data;
  },
};

export default orderApi;